export default __webpack_public_path__ + "assets/images/7361fcd694dab3e6a5b832bafee5e055.png";